import { ClientNode } from '../../../model/client-model/client-node';

export function isLeafNode(node: ClientNode): boolean {
  return !node.childNodes || node.childNodes.length === 0;
}
